import React, { useEffect, useState } from "react";
import { Pagination, Spin, Alert } from "antd";
import "../../../styles/doctors.scss";
import ReviewerCard from "../../Feedback";
import { fetchFeedbacks } from "../../../http/feedbackAPI";

const Reviews = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reviewer, setReviewer] = useState([]);

  useEffect(() => {
    const getReviews = async () => {
      try {
        const data = await fetchFeedbacks();
        console.log("data",data);
        
        setReviewer(Array.isArray(data) ? data : data || []);
      } catch (err) {
        console.error("Error fetching doctors:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    getReviews();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 3;

  const paginatedDoctors = reviewer.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  if (loading) return <Spin tip="Loading reviews..." />;
  if (error) return <Alert type="error" message="Failed to load reviews" />;

  return (
    <div className="doctors-container review-card">
      {reviewer.length > 0 ? (
        <div className="doctors-section">
          {paginatedDoctors.map((doc, index) => (
            <ReviewerCard key={index} reviewer={doc} />
          ))}
        </div>
      ) : (
        <p>No reviewer found</p>
      )}
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={reviewer.length}
        onChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
};

export default Reviews;
